import React from "react";
import styles from "./document-delete.module.scss";
import { useTranslation } from "react-i18next";

interface DocumentItemProps {
  filename: string;
  onDownload?: () => void;
  showDeleteButton?: boolean;
  onDelete?: () => void;
  documentsToDelete?: number[];
  id?: number;
  deleteNew?: () => void;
}

const DocumentDeleteItem: React.FC<DocumentItemProps> = ({
  filename,
  onDownload,
  showDeleteButton = false,
  onDelete,
  documentsToDelete,
  id,
  deleteNew,
}) => {
  const { t } = useTranslation();

  const handleDownload = () => {
    if (onDownload) onDownload();
  };

  const isDeleted =
    documentsToDelete && id !== undefined && documentsToDelete.includes(id);

  return (
    <div
      onClick={handleDownload}
      className={`${styles.documentItem} ${showDeleteButton ? styles.withButton : ""} ${isDeleted ? styles.deleted : ""}`}
    >
      <a
        className={`${styles.filename} ${showDeleteButton ? styles.withButton : ""}`}
      >
        <div className={styles.iconFilename}></div>
        {filename}
      </a>
      {showDeleteButton && !isDeleted && (
        <button
          className={styles.deleteButton}
          onClick={(e) => {
            e.stopPropagation();
            if (deleteNew) {
              deleteNew();
            } else {
              onDelete!();
            }
          }}
        >
          {t("edit-attachments-modal.delete")}
          <div className={styles.icon}></div>
        </button>
      )}
    </div>
  );
};

export default DocumentDeleteItem;
